import wefLogo from "../assets/images/nav/wef_logo.svg"
import brokenLinkImageSmall from "../assets/images/views/broken_link_small.svg"
import brokenLinkImageLarge from "../assets/images/views/broken_link_big.svg"
import placeholderImage from "../assets/images/views/thumb_default.png"
import placeholderImageSVG from "../assets/images/views/graphic_placeholder.svg"
import refreshIcon from "../assets/images/views/refresh_icn.svg"
import searchIconLarge from "../assets/images/views/search_msg.svg"
import moderationApprovedImage from "../assets/images/views/approved_icn.svg"
import moderationRejectedImage from "../assets/images/views/rejected_icn.svg"
import suggestionToApproveImage from "../assets/images/views/likely_approve_icn.svg"
import suggestionToRejectImage from "../assets/images/views/likely_reject_icn.svg"
import twitterSourceImage from "../assets/images/views/twitter_source.svg"
import rssSourceImage from "../assets/images/views/rss_feed_icn.png"
import peopleIcon from "../assets/images/views/communities/people_icn.svg"
import peoplePlaceholder from "../assets/images/views/users/people_placeholder.svg"
import organisationPlaceholder from "../assets/images/views/organization_pl_icn.svg"
import publicOrganisation from "../assets/images/views/public_org_icn.svg"
import emailSent from "../assets/images/login/emailsent_icn.svg"
import placeholderVideoImage from "../assets/images/views/video_placeholder.svg"
import placeholderPodcastImage from "../assets/images/views/podcast_placeholder.svg"
import placeholderReportImage from "../assets/images/views/report_placeholder.svg"

// Flags
import ar from "../assets/images/flags/ar.svg"
import cs from "../assets/images/flags/cs.svg"
import da from "../assets/images/flags/da.svg"
import de from "../assets/images/flags/de.svg"
import en from "../assets/images/flags/en.svg"
import es from "../assets/images/flags/es.svg"
import fr from "../assets/images/flags/fr.svg"
import hu from "../assets/images/flags/hu.svg"
import it from "../assets/images/flags/it.svg"
import ja from "../assets/images/flags/ja.svg"
import nl from "../assets/images/flags/nl.svg"
import no from "../assets/images/flags/no.svg"
import pt from "../assets/images/flags/pt.svg"
import ru from "../assets/images/flags/ru.svg"
import sv from "../assets/images/flags/sv.svg"
import tr from "../assets/images/flags/tr.svg"
import zh from "../assets/images/flags/zh.svg"

// Navs
import dashboardActive from "../assets/images/nav/dashboard_clicked.svg"
import dashboardInactive from "../assets/images/nav/dashboard_unclicked.svg"
import feedActive from "../assets/images/nav/feed_clicked.svg"
import feedInactive from "../assets/images/nav/feed_unclicked.svg"
import clustersActive from "../assets/images/nav/clusters_clicked.svg"
import clustersInactive from "../assets/images/nav/clusters_unclicked.svg"
import sourcesActive from "../assets/images/nav/sources_clicked.svg"
import sourcesInactive from "../assets/images/nav/sources_unclicked.svg"
import insightAreasActive from "../assets/images/nav/insight_areas_clicked.svg"
import insightAreasInactive from "../assets/images/nav/insight_areas_unclicked.svg"
import keyIssuesActive from "../assets/images/nav/key_issues_clicked.svg"
import keyIssuesInactive from "../assets/images/nav/key_issues_unclicked.svg"
import studioBetaActive from "../assets/images/nav/tm_studio_beta_clicked.svg"
import studioBetaInactive from "../assets/images/nav/tm_studio_beta_unclicked.svg"
import communitiesActive from "../assets/images/nav/communities_clicked.svg"
import communitiesInactive from "../assets/images/nav/communities_unclicked.svg"
import usersActive from "../assets/images/nav/user_icn_clicked.svg"
import usersInactive from "../assets/images/nav/user_icn_unclicked.svg"
import stakeholdersActive from "../assets/images/nav/stakeholder_clicked.svg"
import stakeholdersInactive from "../assets/images/nav/stakeholder_unclicked.svg"
import analyticsActive from "../assets/images/nav/analytics_clicked.svg"
import analyticsInactive from "../assets/images/nav/analytics_unclicked.svg"
import notificationsActive from "../assets/images/nav/notification_clicked.svg"
import notificationsInactive from "../assets/images/nav/notification_unclicked.svg"

export const flagsMapping = {
    ar,
    cs,
    da,
    de,
    en,
    es,
    fr,
    hu,
    it,
    ja,
    nl,
    no,
    pt,
    ru,
    sv,
    tr,
    zh,
    "zh-cn": zh,
}

export const navImages = {
    dashboard: {
        active: dashboardActive,
        inactive: dashboardInactive,
    },
    feed: {
        active: feedActive,
        inactive: feedInactive,
    },
    clusters: {
        active: clustersActive,
        inactive: clustersInactive,
    },
    sources: {
        active: sourcesActive,
        inactive: sourcesInactive,
    },
    insightAreas: {
        active: insightAreasActive,
        inactive: insightAreasInactive,
    },
    keyIssues: {
        active: keyIssuesActive,
        inactive: keyIssuesInactive,
    },
    studio: {
        active: studioBetaActive,
        inactive: studioBetaInactive,
    },
    communities: {
        active: communitiesActive,
        inactive: communitiesInactive,
    },
    users: {
        active: usersActive,
        inactive: usersInactive,
    },
    stakeholders: {
        active: stakeholdersActive,
        inactive: stakeholdersInactive,
    },
    analytics: {
        active: analyticsActive,
        inactive: analyticsInactive,
    },
    notifications: {
        active: notificationsActive,
        inactive: notificationsInactive,
    },
}

export const dateSeparator = "/"

// images
export const images = {
    wefLogo,
    brokenLinkImageSmall,
    brokenLinkImageLarge,
    placeholderImage,
    placeholderImageSVG,
    refreshIcon,
    searchIconLarge,
    moderationApprovedImage,
    moderationRejectedImage,
    suggestionToApproveImage,
    suggestionToRejectImage,
    twitterSourceImage,
    rssSourceImage,
    peopleIcon,
    peoplePlaceholder,
    organisationPlaceholder,
    publicOrganisation,
    emailSent,
    placeholderPodcastImage,
    placeholderReportImage,
    placeholderVideoImage,
}
